// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__nIzD3","colCheckbox":"styles_colCheckbox__2IzGG"};